import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CompensationRegularMaximumSettingModel,
  CompensationRegularMaximumSettingPayload,
} from '../../models/teach-compensation/compensation-regular-maximum-setting.model';

@Injectable({ providedIn: 'root' })
export class CompensationRegularMaximumSettingService {
  private readonly apiUrl = '/compensation_regular_maximum_settings';
  private readonly http = inject(HttpClient);

  getSetting(academicTermId: number): Observable<CompensationRegularMaximumSettingModel> {
    return this.http.get<CompensationRegularMaximumSettingModel>(`${this.apiUrl}/${academicTermId}`);
  }

  updateSetting(
    academicTermId: number,
    payload: CompensationRegularMaximumSettingPayload,
  ): Observable<CompensationRegularMaximumSettingModel> {
    return this.http.patch<CompensationRegularMaximumSettingModel>(
      `${this.apiUrl}/${academicTermId}`,
      payload,
    );
  }
}
